import { csx } from '@vtex/admin-ui'

const styles = {
  table: csx({
    width: '100%',
    marginTop: '$space-5',
  }),
  tableHeaderCell: csx({
    textAlign: 'left',
    padding: '2px $space-1',
    backgroundColor: '$secondary',
    '&:first-child': {
      borderTopLeftRadius: '0.25rem',
      borderBottomLeftRadius: '0.25rem',
      width: '146px',
    },
    '&:last-child': {
      borderTopRightRadius: '0.25rem',
      borderBottomRightRadius: '0.25rem',
    },
  }),
  tableBodyCell: csx({
    padding: '$space-3 $space-1 0',
    borderBottom: '1px solid $secondary',
  }),
}

export default styles
